import React from 'react';

import { Facebook, Instagram } from '../../icons';
import Grid from '../Grid';
import {
  StyledColumn,
  StyledColumnList,
  StyledColumnListItem,
  StyledColumnTitle,
  StyledColumnsWrapper,
  StyledLink,
  StyledPrimary,
  StyledSecondary,
  StyledSecondaryList,
  StyledSecondaryListItem,
  StyledSocialLink,
} from './Footer.styles';
import { IFooterProps } from './Footer.types';

const Footer = ({
  content,
  cookiePolicyLink,
  companyInformationsLink,
  termsAndConditionsLink,
  privacyPolicyLink,
  labels,
}: IFooterProps): JSX.Element => {
  const { emailAddress, phoneNumber, vat, vatNumber } = labels;
  const phoneHref = phoneNumber
    ? `tel:${phoneNumber.replace(/\s+/g, '')}`
    : null;

  return (
    <footer>
      <StyledPrimary>
        <Grid container>
          <StyledColumnsWrapper>
            {content.map((item, index) => {
              const { body, title } = item;

              return (
                <StyledColumn key={index}>
                  <StyledColumnTitle>{title}</StyledColumnTitle>
                  <StyledColumnList>
                    {body.map((item, index) => {
                      const { url, text, title } = item;

                      return (
                        <StyledColumnListItem key={index}>
                          <StyledLink href={url} title={title || text}>
                            {text}
                          </StyledLink>
                        </StyledColumnListItem>
                      );
                    })}
                  </StyledColumnList>
                </StyledColumn>
              );
            })}
            <StyledColumn>
              <StyledColumnTitle>{labels?.contactUs}</StyledColumnTitle>
              <StyledColumnList>
                {phoneNumber && phoneHref && (
                  <StyledColumnListItem>
                    <StyledLink href={phoneHref}>{phoneNumber}</StyledLink>
                  </StyledColumnListItem>
                )}
                <StyledColumnListItem>
                  <StyledLink href={`mailto:${emailAddress}`}>
                    {emailAddress}
                  </StyledLink>
                </StyledColumnListItem>
                <StyledColumnListItem>
                  <StyledSocialLink
                    href="https://www.instagram.com/zappyrent/"
                    target="_blank"
                    title="Zappyrent on Instagram"
                  >
                    <span>Zappyrent on Instagram</span>
                    <Instagram />
                  </StyledSocialLink>
                  <StyledSocialLink
                    href="https://www.facebook.com/Zappyrent/"
                    target="_blank"
                    title="Zappyrent on Facebook"
                  >
                    <span>Zappyrent on Facebook</span>
                    <Facebook />
                  </StyledSocialLink>
                </StyledColumnListItem>
              </StyledColumnList>
            </StyledColumn>
          </StyledColumnsWrapper>
        </Grid>
      </StyledPrimary>
      <StyledSecondary>
        <Grid container>
          <StyledSecondaryList>
            <StyledSecondaryListItem>
              <StyledLink
                href={termsAndConditionsLink}
                target="_blank"
                title={labels?.termsAndConditions}
              >
                {labels?.termsAndConditions}
              </StyledLink>
            </StyledSecondaryListItem>
            <StyledSecondaryListItem>
              <StyledLink
                href={cookiePolicyLink}
                target="_blank"
                title="Cookie Policy"
              >
                Cookie Policy
              </StyledLink>
            </StyledSecondaryListItem>
            <StyledSecondaryListItem>
              <StyledLink
                href={privacyPolicyLink}
                target="_blank"
                title="Privacy Policy"
              >
                Privacy Policy
              </StyledLink>
            </StyledSecondaryListItem>
            {companyInformationsLink && (
              <StyledSecondaryListItem>
                <StyledLink
                  href={companyInformationsLink}
                  target="_blank"
                  title={labels?.companyInformations}
                >
                  {labels?.companyInformations}
                </StyledLink>
              </StyledSecondaryListItem>
            )}
            <StyledSecondaryListItem>
              <span>
                {vat}: {vatNumber}
              </span>
            </StyledSecondaryListItem>
          </StyledSecondaryList>
        </Grid>
      </StyledSecondary>
    </footer>
  );
};

export default Footer;
